export const LangsUrl = () => new URL(`/api/v1/lang/`, window.location.origin);

export const GetHeapUrl = () =>
  new URL(`/api/v1/gen/heap`, window.location.origin);
export const RebuildLevelUrl = () =>
  new URL(`/api/v1/gen/rebuild`, window.location.origin);
export const FullLevelUrl = () =>
  new URL(`/api/v1/gen/full`, window.location.origin);

export const DeleteDictUrl = () =>
  new URL(`/api/v1/dict/`, window.location.origin);

export const GetLevelsUrl = (lang: string) =>
  new URL(`/api/v1/level/?lang=${lang}`, window.location.origin);
export const GetLevelUrl = (id: number) =>
  new URL(`/api/v1/level/get?id=${id}`, window.location.origin);
export const SaveLevelUrl = () =>
  new URL(`/api/v1/level`, window.location.origin);
export const DeleteLevelUrl = (id: number) =>
  new URL(`/api/v1/level/${id}`, window.location.origin);
export const GetDifficultyPointsUrl = (lang: string) =>
  new URL(`/api/v1/level/difficulty?lang=${lang}`, window.location.origin);
export const RecalculateDifficultyUrl = (lang: string) =>
  new URL(`/api/v1/level/difficulty/recalculate?lang=${lang}`, window.location.origin);
export const ReorderLevelsByDifficultyUrl = (lang: string) =>
  new URL(`/api/v1/level/reorder-by-difficulty?lang=${lang}`, window.location.origin);

export const GetPackUrl = (lang: string) =>
  new URL(`api/v1/pack/?lang=${lang}`, window.location.origin);
export const GetCurrentPackUrl = (lang: string) =>
  new URL(`api/v1/pack/current?lang=${lang}`, window.location.origin);
export const PostOpenPackUrl = (lang: string) =>
  new URL(`api/v1/pack/open/?lang=${lang}`, window.location.origin);
export const PostReleasePackUrl = (lang: string) =>
  new URL(`api/v1/pack/release/?lang=${lang}`, window.location.origin);
export const PostValidatePackUrl = (lang: string, version: number) =>
  new URL(
    `api/v1/pack/validate/?lang=${lang}&version=${version}`,
    window.location.origin
  );
export const PutPackVersionLimitUrl = () =>
  new URL(`api/v1/pack/version-limit`, window.location.origin);
export const DeletePackUrl = (id: number) =>
  new URL(`api/v1/pack/${id}`, window.location.origin);

export const GetPackSettingsUrl = () =>
  new URL(`api/v1/pack-settings`, window.location.origin);
export const PutPackSettingsUrl = () =>
  new URL(`api/v1/pack-settings`, window.location.origin);

export const JobSubmit = () => new URL(`api/v1/job`, window.location.origin);

export const LoginUrl = () =>
  new URL(`api/v1/auth/login`, window.location.origin);
export const LogoutUrl = () =>
  new URL(`api/v1/auth/logout`, window.location.origin);
export const VerifyLoginUrl = () =>
  new URL(`api/v1/auth/verify`, window.location.origin);

export const GetMilestonesUrl = () =>
  new URL(`api/v1/milestone`, window.location.origin);
export const GetMilestoneUrl = (id: number) =>
  new URL(`api/v1/milestone/${id}`, window.location.origin);
export const PostMilestoneUrl = () =>
  new URL(`api/v1/milestone`, window.location.origin);
export const PutMilestoneUrl = () =>
  new URL(`api/v1/milestone`, window.location.origin);
export const DeleteMilestoneUrl = (id: number) =>
  new URL(`api/v1/milestone/${id}`, window.location.origin);

export const GetClientSettingsUrl = () =>
  new URL(`api/v1/client-settings`, window.location.origin);
export const GetClientSettingUrl = (id: number) =>
  new URL(`api/v1/client-settings/${id}`, window.location.origin);
export const PostClientSettingsUrl = () =>
  new URL(`api/v1/client-settings`, window.location.origin);
export const PutClientSettingsUrl = () =>
  new URL(`api/v1/client-settings`, window.location.origin);
export const DeleteClientSettingsUrl = (id: number) =>
  new URL(`api/v1/client-settings/${id}`, window.location.origin);

export const GetPlayerStatisticsUrl = () =>
  new URL(`api/v1/player-statistics`, window.location.origin);
